import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    setCheckInDay,
    setCheckOutDay,
    setInitialDate,
    setInitialPrice,
} from 'features/userSlice';
import { setCalendar } from 'features/MiniBookingWidget/MiniBookingWidgetSlice';

const useInitCalendar = () => {
    const dispatch = useDispatch();

    // const widgetReady = useSelector(
    //     (state) => state.miniBookingWidget.widgetReady
    // );

    const calendar =
        useSelector((state) => state.miniBookingWidget?.data?.futureDates) ||
        [];

    const checkInDate = useSelector(
        (state) => state.miniBookingWidget?.data?.checkin
    );
    const checkOutDate = useSelector(
        (state) => state.miniBookingWidget?.data?.checkout
    );
    const price = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.price
    );
    const nights = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.nights
    );

    const initialDate = useSelector((state) => state.user?.initialDate);
    const initialPrice = useSelector((state) => state.user?.initialPrice);

    if (initialDate == null) {
        dispatch(setInitialDate(checkInDate));
    }

    if (initialPrice == null || isNaN(initialPrice)) {
        dispatch(setInitialPrice({ price: price, nights: nights }));
    }

    useEffect(() => {
        const updatedCalendar = [...calendar];
        calendar?.forEach((month, index) => {
            const updatedMonth = { ...month };
            const updatedJsonResult = { ...updatedMonth.fd_JsonResult }; // Deep copy of fd_JsonResult
            const updatedData = { ...updatedMonth.fd_JsonResult.data }; // Deep copy of data
            const days = month?.fd_JsonResult?.data?.days;
            const updatedDays = [...days];
            for (let i = 0; i < days.length; i++) {
                const day = days[i];
                const updatedDay = updatedDays[i];
                if (
                    initialDate &&
                    updatedDay?.date === initialDate &&
                    updatedDay?.price &&
                    initialPrice &&
                    updatedDay?.price !== initialPrice
                ) {
                    updatedDays[i] = {
                        ...day,
                        price: initialPrice,
                    };
                }
                if (day?.date === checkInDate?.split('/').reverse().join('-')) {
                    dispatch(setCheckInDay({ day }));
                }

                if (
                    day?.date === checkOutDate?.split('/').reverse().join('-')
                ) {
                    dispatch(setCheckOutDay({ day }));
                }
                // Update the days array in the data object
                updatedDays.days = days;
                // Update the data object in the fd_JsonResult object
                updatedJsonResult.data = updatedData;
                // Update the fd_JsonResult object in the updatedMonth object
                updatedMonth.fd_JsonResult = updatedJsonResult;

                // Replace the original month with the updatedMonth in the calendar
                updatedCalendar[index] = updatedMonth;
                updatedMonth.fd_JsonResult.data.days = updatedDays;
            }
        });
        // Update the state with the copied and modified calendar
        dispatch(setCalendar(updatedCalendar));
    }, [checkInDate]); // used to be [widgetReady]
};

export default useInitCalendar;
